@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.upgrade-button {
  width: 100%;
  height: 48px;
}

.free-trial-button {
  width: 100%;
  height: 24px;
  margin: @space-16 0 @space-24;
}
